import * as React from 'react';
const SvgCross = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M18.657 5.343a1 1 0 0 0-1.414 0L12 10.586 6.757 5.343a1 1 0 1 0-1.414 1.414L10.586 12l-5.243 5.243a1 1 0 1 0 1.414 1.414L12 13.414l5.243 5.243a1 1 0 0 0 1.414-1.414L13.414 12l5.243-5.243a1 1 0 0 0 0-1.414"
    />
  </svg>
);
export default SvgCross;
